/* eslint-disable import/prefer-default-export */
export const checkProp = (prop, noProp, value) => (!noProp ? prop || value : null)
